import type { CurrentProductState } from 'lumen/utils/hotel-and-market/trial-modal-auto-open';
import type { TrialIndicatorProps } from 'shared-react/lumen';

export interface TrialController {
  isTrialModalVisible: boolean;
  productState: {
    currentProductState: CurrentProductState | undefined;
    hasSentTrialContactRequest: () => boolean;
  };
}

export default function createTrialProps(
  controller: TrialController,
): TrialIndicatorProps | undefined {
  const { currentProductState } = controller.productState;
  const daysLeft = currentProductState?.days_left;

  if (
    currentProductState?.subscription_status !== 'trial' ||
    daysLeft === undefined ||
    daysLeft === null
  ) {
    return undefined;
  }

  // The contact request lives in untracked localStorage, so read the modal flag to recompute when the modal closes.
  void controller.isTrialModalVisible;
  const hasSentContactRequest =
    controller.productState.hasSentTrialContactRequest();

  return {
    daysLeft,
    hasSentContactRequest,
    onTrialClick: (): void => {
      if (!hasSentContactRequest) {
        controller.isTrialModalVisible = true;
      }
    },
  };
}
